(() => {
  const selector = 'product-info';
  const patchedAttribute = 'data-gpo-price-compat';

  const patchProductInfo = (productInfo) => {
    if (!productInfo || productInfo.hasAttribute(patchedAttribute) || typeof productInfo.updateButtonPrice !== 'function') return;

    const originalUpdateButtonPrice = productInfo.updateButtonPrice;

    productInfo.updateButtonPrice = function updateButtonPrice() {
      const priceWrapper = this.querySelector('[data-product-price]');
      const currentPrice = priceWrapper?.querySelector('[data-gpo-product-unit-price]');

      if (!priceWrapper || !currentPrice) {
        originalUpdateButtonPrice.call(this);
        return;
      }

      const variant = this.getSelectedVariant(this) || null;
      if (!variant) return;

      const quantity = this.quantityInput && parseInt(this.quantityInput.value || '1', 10) || 1;
      const price = (variant.price || 0) * quantity;
      const compareAtPrice = (variant.compare_at_price || 0) * quantity;

      currentPrice.textContent = price === 0 ? window.theme.strings.free : window.theme.formatMoney(price, window.theme.moneyFormat);

      let comparePrice = priceWrapper.querySelector('[data-gpo-product-compare-at-price]');
      if (compareAtPrice > price) {
        if (!comparePrice) {
          comparePrice = document.createElement('s');
          comparePrice.setAttribute('data-gpo-product-compare-at-price', '');
          priceWrapper.append(' ', comparePrice);
        }
        comparePrice.textContent = window.theme.formatMoney(compareAtPrice, window.theme.moneyFormat);
        comparePrice.hidden = false;
      } else if (comparePrice) {
        comparePrice.hidden = true;
      }
    };

    productInfo.setAttribute(patchedAttribute, '');
  };

  const patchAll = () => document.querySelectorAll(selector).forEach(patchProductInfo);

  customElements.whenDefined(selector).then(patchAll);
  document.addEventListener('theme:product-info:loaded', (event) => patchProductInfo(event.target.closest(selector)));
})();
